import { useContext } from "react";
import { SettingsContext } from "contexts/SettingsContext";

// ==============================|| CONFIG - HOOKS  ||============================== //

const useSettings = () => useContext(SettingsContext);

export default useSettings;